import React, { useEffect, useState } from "react";
import classNames from "classnames";

export type CaretPosition = {
  x: number;
  y: number;
};

type CaretProps = {
  caretPosition: CaretPosition;
};
function Caret({ caretPosition }: CaretProps) {
  const [isBlinking, setIsBlinking] = useState(true);

  useEffect(() => {
    setIsBlinking(false);
    const timeout = setTimeout(() => {
      setIsBlinking(true);
    }, 600);
    return () => {
      clearTimeout(timeout);
    };
  }, [caretPosition]);

  return (
    <div
      style={{
        left: `${caretPosition.x}px`,
        top: `${caretPosition.y}px`,
      }}
      className={classNames(
        "transition-left-top dark:bg-brand-dark-primary absolute h-[1.2em] w-[2px] origin-top-left bg-brand-primary opacity-100 duration-100 ease-in-out",
        {
          "animate-caret-flash-smooth": isBlinking,
        },
      )}
    />
  );
}

export default Caret;
